import { PopUpVariant } from "interfaces";

// Higher number = higher priority (will appear on top among V2 popups)
// Only some variants need explicit entries here; others fall back to 0.
const BASE_PRIORITY: Partial<Record<PopUpVariant, number>> = {
	"pwa-reward-popup": 110,
	"pwa-info-popup": 110,
	"push-permissions-popup": 100
};

export const getPopUpPriority = (variant: PopUpVariant): number => {
	return BASE_PRIORITY[variant] ?? 0;
};

export default getPopUpPriority;
